import React from 'react';
import styled from 'styled-components';
import { useTranslations } from '@libs/translations';
import { Points, textSize } from '@styles';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Top } from './organism/top';
import { Cards } from './organism/cards';

export const DistributorsPage = (cards) => {
  const translations = useTranslations();
  const cardsArray = Object.values(cards?.data?.cards?.items || {});
  return (
    <Container>
      <Top />
      {cardsArray.length > 0 ? (
        <Cards cards={cardsArray} />
      ) : (
        <Content>{translations.t(`site.distributors.noPartners`)}</Content>
      )}
    </Container>
  );
};

const Container = styled.div`
  margin: 0 auto;
`;

const Content = styled.div`
  margin-top: 40px;
  margin-bottom: 400px;
  text-align: center;
  color: ${Colors.dark_500};
  ${textSize('body')};

  @media ${Points.tablet_portrait} {
    margin-top: 50px;
  }

  @media ${Points.laptop_wide} {
    margin-top: 110px;
  }

  @media ${Points.fullhd} {
    margin-top: 110px;
  }
`;
